export const matchRoles = (role, rolesToMatch) => rolesToMatch.includes(role);
